export const tagsTypesList = [
  'custom01',
  'custom02',
  'custom03',
  'custom04',
  'custom05',
  'custom06',
  'custom07',
  'custom08',
  'custom09',
  'custom10',
  'custom11',
  'custom12',
  'custom13',
  'custom14',
  'custom15',
  'custom16',
  'custom17',
  'custom18',
  'default',
  'success',
  'danger',
  'warning',
  'info',
] as const;

export type TTagVariant = typeof tagsTypesList[number];

export const tagSizesTypes = ['small', 'medium', 'large'] as const;
export const tagSizesList = Array.from(tagSizesTypes);
export type TTagSize = typeof tagSizesTypes[number];
